import { environment } from '@env';

const ADMIN_API_PATH = '/admin/';

/** Admin routes implemented on NestJS — skip client mock when mockAdminApi is on. */
const BACKEND_ADMIN_ROUTE_PREFIXES = [
  '/admin/exceptions/dashboard',
  '/admin/auth/',
  '/admin/cases',
] as const;

export function isAdminApiRequest(url: string): boolean {
  return url.includes(ADMIN_API_PATH);
}

export function isBackendAdminRoute(url: string): boolean {
  const path = url.split('?')[0];
  if (BACKEND_ADMIN_ROUTE_PREFIXES.some((prefix) => path.includes(prefix))) {
    return true;
  }
  return /\/admin\/exceptions(\/)?$/.test(path);
}

/**
 * Whether the mock interceptor should handle this request.
 *
 * - mockAdminApi false: all /admin/* calls use the real backend (even when mockApi is true).
 * - mockApi true: consumer routes are mocked; admin follows mockAdminApi rules above.
 * - mockApi false + mockAdminApi true: hybrid — mock unimplemented admin routes only.
 */
export function shouldUseMockApi(url: string): boolean {
  const { mockApi, mockAdminApi } = environment.features;

  if (isAdminApiRequest(url) && !mockAdminApi) {
    return false;
  }

  if (mockApi) {
    return true;
  }

  if (mockAdminApi && isAdminApiRequest(url)) {
    return !isBackendAdminRoute(url);
  }

  return false;
}
